const STORAGE_KEY = 'last_authenticated_org_id';

// tracks the org this browser was last signed into, unconditionally (unlike last_used_org_id,
//  which is only recorded when the "remember login org" preference is on) so a login to a
//  different org can always be detected
export const getLastAuthenticatedOrgId = (): string | null => localStorage.getItem(STORAGE_KEY);

export const setLastAuthenticatedOrgId = (orgId: string): void => localStorage.setItem(STORAGE_KEY, orgId);
